import { readState } from "@/__main__/app-state.mjs";
import {
  getDerivedIdFromSummoner,
  getSummonerFromDerivedId,
} from "@/game-lol/utils/util.mjs";

export default function getCurrentSummoner() {
  const {
    settings: { lastLoggedInIdByGame, loggedInAccounts },
    volatile: { currentSummoner },
  } = readState;

  let derivedId = currentSummoner;
  if (!derivedId) {
    const currentSummoner = loggedInAccounts.lol[lastLoggedInIdByGame.lol];
    if (currentSummoner) derivedId = getDerivedIdFromSummoner(currentSummoner);
    else return [null, null];
  }

  return getSummonerFromDerivedId(derivedId);
}
